import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setReEnrollCompanyId } from '../../../redux/actions/new-space'
import { changeUniversalModal } from '../../../redux/actions/universal'
import { FadeButton } from '../../library/button'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const loading = useSelector(state => state && state.activeCompany && state.activeCompany.loading)
    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const subscription = useSelector(state => state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.subscription)

    const clickNewSpace = () => {
        dispatch(changeUniversalModal({newSpaceModal: true}))
    }

    const clickResubscribe = () => {
        dispatch(changeUniversalModal({resubscribeModal: true}))
    }

    if(!loading && !selectedCompany){
        return <div className="account-notifications-container"><span className="notification-message"><span className="notification-title">Ingen registrerte foretak </span>  <span className="notification-message">Du har ikke registrert et foretak enda </span> <FadeButton size="sm" spacing="left" title="Kom i gang nå" color="green" onClick={() => clickNewSpace()}/></span></div>
    }

    if(!loading && selectedCompany && !subscription){
        return <div className="account-notifications-container"><span className="notification-message"><span className="notification-title">Oppdater abonnement </span>  <span className="notification-message">Du har et inaktivt eller ugyldig abonnement </span> <FadeButton size="sm" spacing="left" title="Oppdater nå" color="green" onClick={() => clickResubscribe(selectedCompany)}/></span></div>
    }

    return null
}

export default Index